import { render, staticRenderFns } from "./employees-item-grant.vue?vue&type=template&id=408f0752"
import script from "./employees-item-grant.vue?vue&type=script&lang=js"
export * from "./employees-item-grant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports